import React, {
  useContext,
  useEffect,
} from 'react';
import { flowRight } from 'lodash';
import {
  injectIntl,
  IntlShape
} from 'react-intl';
import { AppContext } from '../app/AppProvider.component';
import { translateMessages } from '../../translations/message.utilities';
import { AppState } from '../app/app-state.types';
import {
  StaticMessagesKeyMap
} from '../../translations/message.constants';
import { LANGUAGE_KEY } from '../../translations/language.constants';
import { RecordEmpty } from '../../models/common.models';

export const MessagesRegistrarComponent = (props: {
  intl: IntlShape;
}): JSX.Element => {
  const {
    setAppState
  } = useContext(AppContext);

  useEffect(() => {
    const translatedMessages = translateMessages(
        Object.keys(StaticMessagesKeyMap).filter((key) => {
          return StaticMessagesKeyMap[key];
        }) as LANGUAGE_KEY[],
        props.intl
    );
    setAppState((prevState): AppState => {
      return {
        ...prevState,
        messages: translatedMessages
      };
    });
  }, []);

  return null;
};

const enhance = flowRight(
  injectIntl,
);

const MessagesRegistrar: React.ComponentType<RecordEmpty> = enhance(MessagesRegistrarComponent) as React.ComponentType<RecordEmpty>;
export default MessagesRegistrar;
